/*
*
* File JS componente Products Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, {EffectCreative, Navigation} from 'swiper';
Swiper.use([Navigation, EffectCreative]);

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './timeline-slider.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const timelineSlider = () => {
    let timelineYearsSwiper = new Swiper(document.querySelector('.timelineYearsSwiper'), {
        slidesPerView: 1,
        speed: 600,
        // allowTouchMove: false,
        slideToClickedSlide: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 100,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            }
        }
    });

    let timelineImagesSwiper = new Swiper(document.querySelector('.timelineImagesSwiper'),  {
        grabCursor: true,
        effect: "creative",
        speed: 600,
        spaceBetween: 40,
        allowTouchMove: true,
        creativeEffect: {
            prev: {
                shadow: true,
                translate: [0, 0, -400],
                opacity: 0
            },
            next: {
                translate: ["100%", 0, 0],
                opacity: 0
            },
        },
    });

    timelineYearsSwiper.on('slideChange', function () {
        let currentSlideIndex = timelineYearsSwiper.realIndex;
        timelineImagesSwiper.slideTo(currentSlideIndex);
    });
    timelineImagesSwiper.on('slideChange', function () {
        let currentSlideIndex = timelineImagesSwiper.realIndex;
        timelineYearsSwiper.slideTo(currentSlideIndex);
    });
}

export default timelineSlider;

//--------------------------------------------------------------------//